import {
	IconDefinition,
	faClock,
	faLocationDot,
	faTriangleExclamation,
} from '@fortawesome/pro-solid-svg-icons';
import { faArrowUpRightFromSquare } from '@fortawesome/pro-solid-svg-icons';
import { faBurgerSoda } from '@fortawesome/pro-solid-svg-icons';
import { faCalendarWeek } from '@fortawesome/pro-solid-svg-icons';
import { faTrash } from '@fortawesome/pro-solid-svg-icons';
import { faUtensils } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useShoppingCartsContext } from 'context/ShoppingCartsContext';
import { Badge } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Input } from 'reactstrap';
import { tss } from 'tss-react';

import { MenuPlannerItemsBulkResponse } from 'api/menuPlanner/GetMenuPlannerItemsBulk';
import { RenderIf } from 'components/desktop/_general/Conditional/RenderIf';
import FormatedDate from 'components/desktop/_general/FormatedDate/FormatedDate';
import useTranslation from 'hooks/useTranslation';
import { RootState } from 'reducers/rootReducer';
import { Appearance } from 'types/ShoppingCart/Appearance';
import EntityType from 'types/ShoppingCart/EntityType';
import { ShoppingCart } from 'types/ShoppingCart/ShoppingCart';
import Status from 'types/ShoppingCart/Status';

interface IProps {
	source: Appearance.Type;
	cart: ShoppingCart.Type;
	itemOrders: MenuPlannerItemsBulkResponse | null;
}

const SourceHeader = ({ source, cart, itemOrders }: IProps) => {
	const { classes } = useStyles();
	const { tl, t } = useTranslation();
	const carts = useShoppingCartsContext();
	const reduxUser = useSelector((state: RootState) => state.user);

	const getIcon = (): IconDefinition => {
		switch (source.type) {
			case EntityType.MENUPLAN:
				return faCalendarWeek;
			case EntityType.MENU:
				return faBurgerSoda;
			default:
				return faUtensils;
		}
	};

	return (
		<div className={classes.container}>
			{itemOrders && !itemOrders.location.includes('Not found') ? (
				<>
					{reduxUser.firstName == itemOrders.location ? (
						<h6>
							<FontAwesomeIcon
								icon={getIcon()}
								className={classes.icon}
							></FontAwesomeIcon>
							{itemOrders.location} | {tl(source.name)}
						</h6>
					) : (
						<h6>
							<FontAwesomeIcon
								icon={faLocationDot}
								className={classes.icon}
							></FontAwesomeIcon>
							{!itemOrders.location.includes('Not found')
								? itemOrders.location
								: tl(source.name)}
						</h6>
					)}
				</>
			) : (
				<h6>
					<FontAwesomeIcon icon={getIcon()} className={classes.icon}></FontAwesomeIcon>
					{tl(source.name)} | {source.type}
				</h6>
			)}
			<div style={{ display: 'flex' }}>
				{(itemOrders && itemOrders.location.includes('Not found')) ||
				source.type != EntityType.MENUPLAN ? (
					<div
						className="input-group input-group-sm"
						style={{ marginRight: '2rem' }}
						onClick={(event) => {
							event.stopPropagation();
						}}
					>
						<span
							className="input-group-text"
							id="inputGroup-sizing-sm"
							style={{ width: '5rem' }}
						>
							{t('shoppingCart:QUANTITY')}
						</span>
						<Input
							disabled={cart.status === Status.APPROVED}
							type="number"
							className="form-control"
							value={source.quantity}
							onChange={(e) =>
								carts.setQuantity(cart.id, {
									itemId: source.id,
									quantity: Number(e.target.value),
								})
							}
							style={{ width: '5rem' }}
						></Input>
					</div>
				) : (
					<>
						{itemOrders?.items &&
						itemOrders.items.length > 0 &&
						itemOrders.items.every((item) => item.quantity === 0) ? (
							<Badge
								bg="warning"
								style={{
									marginRight: '1rem',
									backgroundColor: 'rgb(255 156 107)',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<FontAwesomeIcon
									style={{
										marginRight: '0.2rem',
									}}
									icon={faTriangleExclamation}
								></FontAwesomeIcon>
								{t('shoppingCart:NO_SUBMISSION_YET')}
							</Badge>
						) : (
							<Badge
								style={{
									marginRight: '1rem',
									backgroundColor: 'rgb(255 156 107)',
									display: 'flex',
									alignItems: 'center',
								}}
							>
								<FontAwesomeIcon
									style={{
										marginRight: '0.2rem',
									}}
									icon={faClock}
								></FontAwesomeIcon>
								{t('shoppingCart:LAST_SUBMISSION')}:
								{itemOrders?.lastEditedDate && (
									<span style={{ marginLeft: '0.2rem' }}>
										<FormatedDate
											date={itemOrders?.lastEditedDate}
										></FormatedDate>{' '}
										- {itemOrders.lastEditedBy}
									</span>
								)}
							</Badge>
						)}
					</>
				)}
				<div
					className="btn btn-outline-primary btn-sm"
					style={{ marginRight: '1rem' }}
					onClick={(event) => {
						window.open(Appearance.getUrl(source));
						event.stopPropagation();
					}}
				>
					<FontAwesomeIcon icon={faArrowUpRightFromSquare}></FontAwesomeIcon>
				</div>
				<RenderIf condition={cart.status !== Status.APPROVED}>
					<div
						className="btn btn-outline-danger btn-sm"
						onClick={async (event) => {
							event.stopPropagation();
							await carts.removeAppearance(cart.id, source.id);
						}}
					>
						<FontAwesomeIcon icon={faTrash}></FontAwesomeIcon>
					</div>
				</RenderIf>
			</div>
		</div>
	);
};

export default SourceHeader;

export const useStyles = tss.create({
	container: {
		display: 'flex',
		alignItems: 'flex-end',
		justifyContent: 'space-between',
		width: '100%',
		paddingRight: '1rem',
	},
	img: {
		width: '40px',
		height: '40px',
	},
	labelWidth: {
		width: '5rem',
	},
	icon: {
		marginRight: '8px',
		opacity: '0.6',
	},
});
